<template>
  <v-app id="inspire" :class="showMainContent?'bg-black':''">
    <v-btn fab small class="menu-btn" style="position:absolute;" @click="flagMenu=!flagMenu">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-overlay :value="mainLoader" z-index="7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <sidebar v-if="flagMenu && showMainContent" @hideFlag="flagMenu=!flagMenu"></sidebar>
    <v-main v-if="showMainContent">
      <v-container
          class="fill-height rj"
          :class="flagMenu?'filler':''"
          fluid
      >
        <router-view/>
      </v-container>
    </v-main>
    <login :dialog="modalLogin"></login>
		<v-snackbar v-model="snackbar" :color="colorSnack" :timeout="10000">
			{{ textSnack }}
			<template v-slot:action="{ attrs }">
				<v-btn
						text
						dark
						v-bind="attrs"
						@click="snackbar = false">
					Ok
				</v-btn>
			</template>
		</v-snackbar>
  </v-app>
</template>

<script>
import {mapActions, mapState} from "vuex";
import axios from 'axios'
import Sidebar from '@/components/Sidebar.vue'
import Login from '@/components/Login.vue'

export default {
  components: {
    Sidebar,
    Login
  },
  props: {
    source: String,
  },
  computed: {
    ...mapState(['mainLoader']),
  },
  data: () => ({
    drawer: true,
    overlay: true,
    modalLogin: false,
    email: "",
    password: "",
    flagMenu: true,
    showMainContent: false,
    snackbar: false,
    textSnack: '',
    colorSnack: 'success'
  }),
  methods: {
    ...mapActions(['loaderChange']),
    ...mapActions(['fetchInfo']),
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      sessionStorage.setItem('url', window.location.href);
    }
    const userToken = localStorage.getItem('token')
    if (!userToken) {
      this.modalLogin = true
    } else {
      this.showMainContent = true
      this.fetchInfo()
    }
    axios.interceptors.response.use(response => {
      return response;
    }, error => {
      if (error.response.status === 401) {
        if (localStorage.getItem('token')) {
          this.snackbar = true,
          this.textSnack = 'Su sesión ha expirado'
          this.colorSnack =  'error'
        }
        localStorage.removeItem('token')
        this.modalLogin = true
      }
      return Promise.reject(error.response);
    })
  }
}
</script>
<style lang="scss">
@font-face {
  font-family: 'Virgula Vulgaris';
  src: url("./assets/fonts/Virgula-Vulgaris.woff") format("woff");
}

@font-face {
  font-family: 'Avenir';
  src: url("./assets/fonts/Avenir/Avenir-Light.woff") format("woff");
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'Avenir';
  src: url("./assets/fonts/Avenir/Avenir-Roman.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Avenir';
  src: url("./assets/fonts/Avenir/Avenir-Medium.woff") format("woff");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Avenir';
  src: url("./assets/fonts/Avenir/Avenir-Heavy.woff") format("woff");
  font-weight: 800;
  font-style: normal;
}

* {
  font-family: "Avenir", sans-serif;
}

.container.fill-height.rj {
  align-items: flex-start;
  background-image: url("./assets/decoration.png");
  padding: 30px 40px;

  p {
    margin-bottom: 30px;
    font-size: 14px;
  }

  label {
    font-size: 16px;
    line-height: 22px;
    display: inline-block;
    color: #656565;
  }

  .v-input:not(.excluded) input, .v-select__selection {
    padding: 0;
    margin-bottom: 0;
    margin-top: 0;
    line-height: 22px;
    font-size: 16px;
    font-weight: 200;
  }

  .v-text-field:not(.excluded) {
    padding-top: 0;
    margin-bottom: 14px;
    margin-top: 2px;
  }

  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: 5px 5px 4.86px #0000001a;
    border-radius: 8px;
  }
}

h1 {
  font-family: 'Virgula Vulgaris';
  font-weight: 200;
  color: #656565;
}

.main-description {
  font-weight: 200;
  font-size: 12px;
  color: #656565;
  margin-top: 12px;

  a {
    margin-top: 6px;
    display: inline-block;
    font-weight: 400;
  }
}

.rj-content {
  width: 100%;

  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #b3b3b3 !important;
    color: #fff !important;
  }

  .theme--light.v-select .v-select__selection--comma {
    color: #656565;
  }

  .v-btn--outlined {
    border-width: 2px;
    font-weight: 600;
  }
}

.v-list-item__content {
  color: #656565;
}

.v-btn {
  width: 160px;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.v-btn__content {
  text-transform: none;
}

.edit-btn {
  position: absolute;
  top: 16px;
  right: 10px;
  display: block;
  width: 30px;
  height: 30px;
  z-index: 1;
  cursor: pointer;
  filter: brightness(0.6);
  i {
    display: block;
    width: 28px;
    height: 25px;
    background-size: cover;
    background-image: url("./assets/pencil.png");

    &:hover, &.active {
      background-image: url("./assets/pencil-active.png");
    }
  }
}

.v-picker__title {
  border-radius: 0 !important;
}

.dialog-appointment {
  .logo {
    width: 75px;
    margin: 40px auto 50px;
    display: block;
  }

  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #CBCBCB;
    border-radius: 50% !important;
    color: #fff;
    font-size: 15px;
    width: 30px;
    height: 30px;
  }

  .modal-text {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;

    span {
      color: #2C8886;
    }
  }

  ::v-deep .btn-continue {
    display: block;
    margin: 30px auto 10px;
  }

  .ctn-img {
    margin-top: 40px;

    img {
      width: 75px;
    }
  }
}

.filler {
  opacity: 1;
  transition: opacity ease-out 0.6s;
}

@mixin mobile {
  @media screen and (max-width: 768px) {
    @content;
  }
}

@include mobile {
  .filler {
    opacity: 0 !important;
    transition: opacity ease-out 0.6s;
  }
  .container.fill-height.rj {
    padding: 15px 20px;
  }
  .v-dialog {
    width: 100% !important;
  }
}

.menu-btn {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 99;
  display: none !important;
  @include mobile {
    display: block !important;
  }
}

.v-main {
  overflow: hidden;
}

.theme--light.v-list-item--active:focus:before, .theme--light.v-list-item.v-list-item--highlighted:before {
  opacity: 0.2;
}

.v-list-item--link:before {
  background: #29AAE1 !important;
}

.dialog-appointment {
  border-radius: 15px;

  .logo {
    width: 75px;
    margin: 40px auto 5px;
    display: block;
  }

  .title-modal {
    font-size: 18px;
    text-align: center;
    margin-bottom: 12px;
  }

  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #CBCBCB;
    border-radius: 50% !important;
    color: #fff;
    font-size: 15px;
    width: 30px;
    height: 30px;
  }

  .modal-text {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;

    span {
      color: #2C8886;
    }
  }

  ::v-deep .btn-continue {
    display: block;
    margin: 30px auto 10px;
  }

  .ctn-img {
    margin-top: 40px;

    img {
      width: 75px;
    }
  }
}

// pass to admin
.action-btn {
  display: inline-block;
  background-size: cover;
  height: 18px;
  filter: contrast(0.8);
  vertical-align: middle;
  margin: 0 4px;
}

.edit-pencil {
  width: 20px;
  background-image: url("./assets/pencil.png");

  &:hover, &.active {
    background-image: url("./assets/pencil-active.png");
  }
}

.remove-can {
  width: 16px;
  background-image: url("./assets/delete.png");

  &:hover, &.active {
    background-image: url("./assets/delete-active.png");
  }
}

.v-tooltip__content {
  background: #B4B4B4 !important;
}

.btn-size-auto {
  .v-btn--outlined {
    border-width: 2px;
    font-weight: 600;
  }

  .v-btn {
    width: auto;
    min-width: 120px !important;
  }
}
.save-btn.ml-4 {
  margin-left: auto !important;
}
.bg-black {
  background: #212121;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tbody>tr>th, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th, .v-data-table>.v-data-table__wrapper>table>thead>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>th{
  padding: 0 10px !important;
}
</style>
